export default __webpack_public_path__ + "static/media/gitbook.a9750f04.svg";